
import {Options, Vue} from 'vue-class-component';
import './../less/lifetime-award.less'
import Gallery from "@/components/Gallery.vue";
import RegistrationForm from './RegistrationForm.vue';
import WinnerGallery from "@/components/WinnerGallery.vue";
import Logo from "@/components/Logo.vue";

@Options({
    components: {
        Gallery,
        WinnerGallery,
        Logo,
        RegistrationForm
    },
})
export default class LifetimeAwardPage extends Vue {
    isOpenMenu = false
    isEnabledRegistration = false

    mounted() {
        document.title = 'HBA - Üzleti Életműdíj'
    }

    menuToggle() {
        this.isOpenMenu = !this.isOpenMenu
    }

    showRegistration() {
        this.isEnabledRegistration = true
        setTimeout(() => {
            window.location.href = "#form";
        }, 200)
    }
}
